import './src/styles/global.scss';
import "./node_modules/slick-carousel/slick/slick.scss";
import './node_modules/slick-carousel/slick/slick-theme.scss';

